import {
  LOGO_MAPPING,
  LOGO_MAPPING_COLORS,
} from "../../../../../assets/js/src/general/utils";

const defaultIcon = "fa-solid fa-link";
const defaultIconColor = "primary_50";

// Returns icon or color based on mapping provided
const socialLinkProperty = (link, MAPPING, defaultValue) => {
  const key = Object.keys(MAPPING).find((k) => link.includes(k));
  return key ? MAPPING[key] : defaultValue;
};

export const socialLinkIcon = (link) =>
  socialLinkProperty(link, LOGO_MAPPING, defaultIcon);

export const socialLinkColor = (link) =>
  socialLinkProperty(link, LOGO_MAPPING_COLORS, defaultIconColor);
